module.exports = __webpack_public_path__ + "img/juyanyan.21879057.jpg";